// extracted by mini-css-extract-plugin
export default {"text":"SelectionActions_text__uS8cv","placeHolderShimmer":"SelectionActions_placeHolderShimmer__3MNOp"};